<template>
  <div class="vip-card-group">
    <div class="inner_center">
      <div class="swiper-box">
        <!-- 控制swiper -->
        <div class="swiper-more">
          <span class="txt-more">查看更多</span>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>



        <div
          v-swiper:mySwiper3="swiperOption3"
          class="swiper swiper3"
        >
          <div class="swiper-wrapper">
            <div
              :class="vo.className"
              class="card-item swiper-slide"
              v-for="(vo,idx) in vipCardList.slice(0,vipCardList.length-1)"
              :key="vo.value"
            >
              <!--        <i
                        v-if="vo.ID == 36 || vo.ID == 37"
                        class="icon_bug" />-->
              <div
                class="card-header"
                :class="'card-header' + (idx+1)"
              >
                <div class="title">{{ vo.LABEL }}</div>
                <div class="sub-title _hide" v-if="vo.subTitle">
                  <span class="text-main">{{ vo.subTitle.main }}</span>
                  |
                  <span class="text-account">{{ vo.subTitle.account }}</span>
                </div>
              </div>
              <i class="icon_custom" v-if="vo.ID == -1"></i>
              <div class="card-content">
                <div class="price-box" v-if="vo.ID != -1">
                  <i class="icon_dollar">￥</i>
                  <span class="price">{{ vo.PRICE }}</span>
                  <span class="time">{{ vo.time }}</span>
                </div>
                <div class="price-box price-box2" v-else>
                  <!--            <i class="icon_dollar">￥</i>-->
                  <!--            <span class="price">{{ vo.price }}</span>-->
                  <!--            <span class="time">{{ vo.time }}</span>-->

                  <i class="icon_company"/>
                  自由定制
                </div>

                <div class="main-box">
                  <div class="sub-title " v-if="vo.subTitle">
                    <span class="text-main">{{ vo.subTitle.main }}</span>
                    |
                    <span class="text-account">{{ vo.subTitle.account }}</span>
                  </div>
                  <div class="down-num">
                    {{ vo.downNum }}
                  </div>
                </div>
                <div class="buy" v-if="vo.ID != -1" @click="buy(vo)">
                  {{ '立即开通' }}
                </div>
                <a href="/introduce/company-plus" target="_blank" class="buy buy-service" v-else>
                  {{ '立即查看' }}
                </a>

                <div class="scene-hr scene-hr-team">
                  <div class="scene-text">
                    {{ '权益保障' }}
                  </div>
                </div>
                <div class="permission-list interests" v-if="vo.interests && vo.interests.length">
                  <div
                    v-for="(permItem,permIdx) in vo.interests.slice(0,1)"
                    :key="permIdx"
                    class="permission-item"
                    @click="showCertificate(vo,idx)"

                  >
                    <i v-if="permItem != ''" :class="['iconfont','icon-gou2']"/>
                    <span>{{ permItem }}</span>
                  </div>

                  <div
                    v-for="(permItem,permIdx) in vo.interests.slice(1)"
                    :key="permIdx"
                    class="permission-item"
                  >
                    <i v-if="permItem != ''" :class="['iconfont','icon-gou2']"/>
                    <span v-html="permItem"></span>
                  </div>
                </div>

                <div class="scene-hr scene-hr-team">
                  <div class="scene-text">
                    {{ '授权范围' }}
                  </div>
                </div>

                <div class="permission-list">
                  <div
                    v-for="(permItem,permIdx) in vo.scope"
                    :key="permIdx"
                    class="permission-item">
                    <i :class="['iconfont','icon-gou2']"/>
                    <span>{{ permItem }}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>
      </div>

      <div
        :class="vo.className"
        class="card-item swiper-slide swiper-slide-custom"
        v-for="(vo,idx) in vipCardList.slice(-1)"
        :key="vo.value"
      >
        <!--        <i
                  v-if="vo.ID == 36 || vo.ID == 37"
                  class="icon_bug" />-->
        <div
          class="card-header"
          :class="'card-header' + (idx+1)"
        >
          <div class="title">{{ vo.LABEL }}</div>
          <div class="sub-title _hide" v-if="vo.subTitle">
            <span class="text-main">{{ vo.subTitle.main }}</span>
            |
            <span class="text-account">{{ vo.subTitle.account }}</span>
          </div>
        </div>
        <i class="icon_custom" v-if="vo.ID == -1"></i>
        <div class="card-content">
          <div class="price-box" v-if="vo.ID != -1">
            <i class="icon_dollar">￥</i>
            <span class="price">{{ vo.PRICE }}</span>
            <span class="time">{{ vo.time }}</span>
          </div>
          <div class="price-box price-box2" v-else>
            <!--            <i class="icon_dollar">￥</i>-->
            <!--            <span class="price">{{ vo.price }}</span>-->
            <!--            <span class="time">{{ vo.time }}</span>-->

            <i class="icon_company"/>
            自由定制
          </div>

          <div class="main-box">
            <div class="sub-title " v-if="vo.subTitle">
              <span class="text-main">{{ vo.subTitle.main }}</span>
              |
              <span class="text-account">{{ vo.subTitle.account }}</span>
            </div>
            <div class="down-num">
              {{ vo.downNum }}
            </div>
          </div>
          <div class="buy" v-if="vo.ID != -1" @click="buy(vo)">
            {{ '立即开通' }}
          </div>
          <a href="/introduce/company-plus" target="_blank" class="buy buy-service" v-else>
            {{ '立即查看' }}
          </a>

          <div class="scene-hr scene-hr-team" v-if="vo.interests && vo.interests.length">
            <div class="scene-text">
              {{ '权益保障' }}
            </div>
          </div>
          <div class="permission-list interests" v-if="vo.interests && vo.interests.length">
            <div
              v-for="(permItem,permIdx) in vo.interests.slice(0,1)"
              :key="permIdx"
              class="permission-item"
              @click="showCertificate(vo,idx)"

            >
              <i :class="['iconfont','icon-gou2']"/>
              <span>{{ permItem }}</span>
            </div>

            <div
              v-for="(permItem,permIdx) in vo.interests.slice(1)"
              :key="permIdx"
              class="permission-item"
            >
              <i :class="['iconfont','icon-gou2']"/>
              <span v-html="permItem"></span>
            </div>
          </div>

          <div class="scene-hr scene-hr-team">
            <div class="scene-text">
              {{ '授权范围' }}
            </div>
          </div>

          <div class="permission-list">
            <div
              v-for="(permItem,permIdx) in vo.scope"
              :key="permIdx"
              class="permission-item">
              <i :class="['iconfont','icon-gou2']"/>
              <span>{{ permItem }}</span>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {
  BUSINESS_VIP_INFO, BUSINESS_VIP_MONTH_INFO, PERSON_QUARTER_MONTH_INFO, PERSON_VIP_INFO
} from "@/constant/VIP";
import {permission} from "@/components/introduce/common/module";
import {
  COMPANY_All_PURPOSE,
  COMPANY_ONLINE,
  COMPANY_RESALE,
  COMPANY_SENIOR,
  COMPANY_UPGRADE
} from "@/constant/VIP_COMPANY";
import {tag} from "@/utils/statUtil";
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

const vipCardList = [
  {
    // ...VIP_MANAGE.COMPANY.BASIC_100,
    // ...VIP_MANAGE.COMPANY.VIP_A,
    ...VIP_MANAGE.PERSON.YEAR_SIMPLE,
    versionName: '普通版-2个子帐号',
    // version: '基础版',
    version: '全站通套餐A',
    time: '年',
    downloadNum:"100张",
    dj:"",
    subTitle: {
      main: '1家主体',
      account: VIP_MANAGE.COMPANY.VIP_A.ACCOUNT_NUMBER + '个帐号'
    },
    interests: [
      // `「${VIP_MANAGE.COMPANY.VIP_A.LABEL}」商用授权书`,
      // '注册资本≤1000万',
    ],
    scope: [
      '仅限个人学习交流使用',
      // '新媒体用途',
    ],
    downNum: "3张/天",
    desc: '「普通版」商用授权书',
    personMax: '¥399/人',
    priceDesc: '2张/天',
    // tagClass: 'company-upgrade',
    mandateNum: '企业普通版VIP（共12项授权）',
    mandateNum2: `企业普通版VIP·共12项授权 ，  授权对象须注册资本≤500万 <p>（若注册资本＞500万，请购买更高版本）</p>`,
    ziben:"≤500万",
    equitySimple: [
      {
        isHas: 1,
        label: '企业商用授权'
      },
      {
        isHas: 1,
        label: '商用海量下载'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '在线申请发票'
      },
      {
        isHas: 1,
        label: '专属客服1对1'
      },
    ],

    scopePermission: [
      1,
      1,
      1,
      1,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
    quanyi:[
      {
        label:"新媒体用途",
        value: 1
      },
      // {
      //   label:"电商用途",
      //   value: 1
      // },
    ],

    isShow: true,
    downScope: ['企业VIP专享', '个人VIP专享', '限时免费'],
    downTxt:'VIP专区+限时免费',

  },
  {
    ...VIP_MANAGE.COMPANY.VIP_B,

    versionName: '体验版-1个子帐号',
    // version: '普通版',
    version: '全站通套餐B',
    newName: '普通版',
    time: '/年',
    dj:"80%用户选择",
    desc: '「体验版」商用授权书',
    subTitle: {
      main: '1家主体',
      account: VIP_MANAGE.COMPANY.VIP_B.ACCOUNT_NUMBER + '个帐号'
    },
    interests: [
      `「${VIP_MANAGE.COMPANY.VIP_B.LABEL}」商用授权书`,
      '注册资本≤1000万',
      // '享￥2,000保障金',
    ],
    scope: [
      '新媒体用途',
      // '电商用途',
      // '广告宣传',
    ],
    downNum: '全站海量下载+图片包',
    // tagClass: 'company-all',
    personMax: '¥999/人',
    priceDesc: '全站200张/年（含图片包）',
    mandateNum: '企业体验版VIP（共10项授权）',
    ziben:"≤100万",
    mandateNum2: `企业体验版VIP·共10项授权 ，  授权对象须注册资本≤100万 <p>（若注册资本＞100万，请购买更高版本）</p>`,
    equitySimple: [
      {
        isHas: 1,
        label: '企业商用授权'
      },
      {
        isHas: 1,
        label: '商用200张/年'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '在线申请发票'
      },
      {
        isHas: 1,
        label: '专属客服1对1'
      },
    ],
    scopePermission: [
      1,
      1,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
    isShow: true,
    downScope: ['企业VIP专享', '个人VIP专享', '限时免费'],
    quanyi:[
      {
        label:"新媒体用途",
        value: 1
      },
      {
        label:"电商用途",
        value: 1
      },
      {
        label:"享2千理赔金",
        value: 1
      }
    ]

  },
  {
    ...VIP_MANAGE.COMPANY.BASIC,
    label: COMPANY_All_PURPOSE.FULL_NAME2,
    name: '基础版',
    subTitle: {
      main: '1家主体',
      account: VIP_MANAGE.COMPANY.BASIC.ACCOUNT_NUMBER + '个帐号'
    },
    downNum: '全站海量下载+图片包',
    value: 2,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    time: '/年',
    interests: [
      `「${VIP_MANAGE.COMPANY.BASIC.LABEL}」商用授权书`,
      '注册资本≤1000万',
      '享￥20,000保障金',
    ],
    scope: [
      '新媒体用途',
      '电商用途',
      '广告宣传',
      '线下用途',
    ]
  },
  // {
  //   ...VIP_MANAGE.COMPANY.BASIC,
  //   name: '普通版',
  //   subTitle: {
  //     main: '1家主体',
  //     account: VIP_MANAGE.COMPANY.BASIC.ACCOUNT_NUMBER + '个帐号'
  //   },
  //   downNum: '全站海量下载+图片包',
  //
  //   value: 2,
  //   desc: '商用授权，全渠道使用',
  //   className: 'business-vip',
  //   time: '/年',
  //   interests: [
  //     '「普通版」商用授权书',
  //     '微型企业（注册资本≤500万）',
  //     '享￥5,000保障金',
  //   ],
  //   scope: [
  //     '线上全用途',
  //     '广告宣传',
  //     '线下用途',
  //   ]
  // },
  {
    ...VIP_MANAGE.COMPANY.MAJOR,
    name: '专业版',
    subTitle: {
      main: '1家主体',
      account: VIP_MANAGE.COMPANY.MAJOR.ACCOUNT_NUMBER +'个帐号'
    },
    downNum: '全站海量下载+图片包',

    value: 2,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    time: '/年',
    interests: [
      `「${VIP_MANAGE.COMPANY.MAJOR.LABEL}」商用授权书`,
      '注册资本≤1000万',
      '享￥30,000保障金',
    ],
    scope: [
      '新媒体用途',
      '电商用途',
      '线下用途',
      '广告宣传',
      '传媒影视',
    ]
  },
  {
    ...VIP_MANAGE.COMPANY.RELEASE,
    name: '发行版',
    subTitle: {
      main: '1家主体',
      account: VIP_MANAGE.COMPANY.RELEASE.ACCOUNT_NUMBER + '个帐号'
    },
    downNum: '全站海量下载+图片包',

    value: 2,
    desc: '商用授权，全渠道使用',
    className: 'business-vip',
    time: '/年',
    interests: [
      `「${VIP_MANAGE.COMPANY.RELEASE.LABEL}」商用授权书`,
      '注册资本≤1000万',
      '享￥60,000保障金',
    ],
    scope: [
      '新媒体用途',
      '电商用途',
      '线下用途',
      '广告宣传',
      '转售商品',
      '传媒影视',
    ]
  },
  {
    LABEL: '企业PLUS版',
    subTitle: {
      main: '1家主体起',
      account: '1个帐号起'
    },
    downNum: '全站海量下载+图片包',

    value: 2,
    ID: -1,
    PARENT_ID: COMPANY_RESALE.PARENT_ID,
    desc: '商用授权，全渠道使用',
    className: 'business-vip custom',
    price: '8800',
    time: '起',
    interests: [
      '「定制版」商用授权书',
      `注册资本＞1000万 <br> 国企/大型企业/事业单位`,
      '享最高保障金',
    ],
    scope: [
      '不限',
    ]
  },

  // {
  //   label: '企业定制',
  //   subTitle:'多家主体 | 多个帐号',
  //   value: 3,
  //   // ID: -1,
  //   ID: COMPANY_All_PURPOSE.ID,
  //   price: COMPANY_All_PURPOSE.PRICE,
  //   time: '/年',
  //   desc: '多家主体 | 多个帐号',
  //   className: 'company-vip',
  //   descList: [
  //     '企业商用授权',
  //     '多主体',
  //     '多帐号',
  //     '全站海量+图片包',
  //     '￥5000/1家主体',
  //     '全球',
  //     '永久',
  //   ],
  //   permissionArr: [1, 1, 1, 1, 1, 1, 1],
  //   useSceneText: '适用企业',
  //   useScene: [
  //     {
  //       label: '线上曝光',
  //       value: '无限制'
  //     },
  //     {
  //       label: '线下印刷',
  //       value: '限5万份/一家主体'
  //     },
  //     {
  //       label: '图书出版',
  //       value: '限10万份/一家主体'
  //     },
  //     {
  //       label: '户外广告',
  //       value: true
  //     },
  //     {
  //       label: '转售商品',
  //       value: true
  //     },
  //     {
  //       label: '影视制作',
  //       value: false
  //     },
  //
  //   ],
  //   useTeam:{
  //     label:'中大型团队：',
  //     value:'支持线上/线下所有场景，可定制主体/下载帐号数量。支持户外宣传、转售商品、线下印刷、图书出版。'
  //   },
  // },
]

/* 授权范围 */
const License = [
  {
    label: '线上曝光',
    iconClass: 'icon-a-6xianshang',
  },
  {
    label: '线下印刷',
    iconClass: 'icon-a-10printer',
  },
  {
    label: '图书出版',
    iconClass: 'icon-a-11book',
  },
  {
    label: '户外广告',
    iconClass: 'icon-a-8huwai',
  },
  {
    label: '转售商品',
    iconClass: 'icon-a-16resell',
  },
  {
    label: '影视制作',
    iconClass: 'icon-a-8huwai',
  },
]

const permissionCompany = [
  {
    label: '商用授权',
    iconClass: 'icon-a-1shang'
  },
  {
    label: '授权主体',
    iconClass: 'icon-com'
  },
  {
    label: '下载帐号',
    iconClass: 'icon-user'
  },
  {
    label: '内容下载',
    iconClass: 'icon-a-2img'
  },
  {
    label: '赔付保障',
    iconClass: 'icon-money'
  },
  {
    label: '授权地域',
    iconClass: 'icon-global'
  },
  {
    label: '授权期限',
    iconClass: 'icon-date'
  },
]

export default {
  name: "CompanyVipCardGroup",
  data() {
    return {
      vipCardList,
      permission,
      BUSINESS_VIP_INFO, PERSON_VIP_INFO,
      permissionCompany,
      License,
      swiperOption3: {
        // autoplay: {
        //   delay: 1000,
        //   speed: 500,
        //   disableOninteraction: true
        // },
        //配置分页
        pagination: {
          el: '.swiper-pagination'//分页的dom节点
        },
        speed: 300,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        direction: "horizontal",
        slidesPerView: 4,
        spaceBetween: 24,
        initialSlide: 1, // 默认选中
        loop: false, // 在此无效？？？？？
        // centeredSlides: true, //活动块居中
        // slideToClickedSlide: false, // 点击切换
        lazy: true,
        // slidesPerView:'auto',
        allowTouchMove: false,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper3");
            // console.log("轮播图滚动事件 --->", c_swiper[0].swiper.activeIndex )
            // this.swiperOption3.initialSlide = c_swiper[0].swiper.activeIndex - 4
          },
        }
      },
    }
  },
  methods: {
    buy(vipInfo) {
      this.$emit('buy', vipInfo)
    },
    tag(stat) {
      tag(stat)
    },
    showCertificate(vo,idx) {
      console.log({
        vo
      })
      if (vo.interestsFlag == undefined && vo.ID > -1){
        this.$emit('showCertificate', vo.ID)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.swiper-box{
  width: 1040px;
  margin-top: -20px;
  position: relative;

  .swiper3{
    overflow: hidden;
  }
  .swiper-wrapper{
    padding-top: 20px;
    //margin-top: -20px;
    box-sizing: border-box;
  }

  .swiper-more{
    width: 32px;
    height: 90px;
    background: #FFFFFF;
    border-radius: 4px;
    position: absolute;
    left: -56px;
    top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:hover{
      background: rgba(255, 255, 255, 0.85);
    }

    .txt-more{
      display: inline-block;
      width: 16px;
      height: 58px;
      font-size: 12px;
      color: #6969FF;
      line-height: 14px;
      letter-spacing: 1px;
      text-align: center;
      margin-top: 8px;
    }

    .swiper-button-prev,
    .swiper-button-next
    {
      &:after{
        content: '';
        display: inline-block;
        width: 32px;
        height: 90px;
        border-radius: 4px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .swiper-button-next{
      @include BgImage2(22px,22px,'pay/arrow@hover.png');
      transform: rotate(180deg);
      position: static !important;
      margin-top: -0px !important;
      &:hover{
        @include BgImage2(22px,22px,'pay/arrow@hover.png');
        transform: rotate(180deg);
      }
      &.swiper-button-disabled{
        @include BgImage2(22px,22px,'pay/arrow.png');
        display: none;
      }
    }
    .swiper-button-prev{
      @include BgImage2(22px,22px,'pay/arrow@hover.png');
      left: -30px;
      position: static !important;
      margin-top: -0px !important;
      &:hover{
        @include BgImage2(22px,22px,'pay/arrow@hover.png');
      }
      &.swiper-button-disabled{
        @include BgImage2(22px,22px,'pay/arrow.png');
        display: none;
      }
    }
  }
}
.vip-card-group {
  width: 100%;
  position: absolute;
  top: 397px;
  left: 50%;
  transform: translateX(-50%);


  .inner_center {
    display: flex;
    align-items: center;
    justify-content: center;
    //justify-content: space-between;
    width: 1306px !important;

    @include Screen(1) {
      //width: 1200px !important;
    }
  }

  .card-item {
    width: 242px;
    height: 547px;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 26, 0.1);
    border-radius: 14px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    margin-right: 24px;
    position: relative;

    .icon_bug {
      @include BgImage(114px, 28px, 'pay/icon_buy.png');
      position: absolute;
      left: 50%;
      top: -8px;
      transform: translateX(-50%);
    }

    &:last-child {
      margin-right: 0;
    }

    @mixin CardHeaderTitle($color: transparentize) {
      color: $color;
      .title, .text-main {
        color: $color;
      }
    }





    @for $i from 1 to 6{
      .card-header#{$i} {
        //width: #{$i}px !important;
        @include BgImage(242px, 60px, 'introduce/company/CompanyVipCardGroup/header_#{$i}.png');
      }
    }


    @include Screen(1) {
      width: 242px;
      margin-right: 25px;
      &:last-child {
        margin-right: 0;
      }

      @for $i from 1 to 5 {
        .card-header#{$i} {
          //width: #{$i}px !important;
          @include BgImage(242px, 60px, 'introduce/company/CompanyVipCardGroup//card-header-bg#{$i}.png');
        }
      }
    }


    .card-header {
      //background: #35D0BA;
      border-radius: 14px 14px 0px 0px;
      text-align: center;
      color: #FFFFFF;


      &.card-header1 {
        @include CardHeaderTitle(rgba(177, 119, 81, 1))
      }

      &.card-header2 {
        @include CardHeaderTitle(rgba(179, 77, 41, 1))
      }

      &.card-header3 {
        @include CardHeaderTitle(rgba(179, 77, 41, 1))
      }

      &.card-header4 {
        @include CardHeaderTitle(rgba(179, 77, 41, 1))
      }

      &.card-header5 {
        @include CardHeaderTitle(rgba(179, 77, 41, 1))
      }

      &.card-header6 {
        @include CardHeaderTitle(rgba(52, 57, 129, 1))
      }

      .title {
        font-weight: bold;
        letter-spacing: 1px;

        //margin: 16px 0 4px;

        font-size: 16px;
        //color: #89462C;
        line-height: 60px;
      }

      .sub-title {
        letter-spacing: 1px;
        //color: #B17751;
        line-height: 16px;

        .text-main {

        }

        .text-account {
          color: rgba(248, 90, 31, 1);
          font-weight: bold;
        }


      }

      .desc {
        font-size: 13px;
        line-height: 18px;
      }
    }

    .card-content {
      //width: 100%;
      //box-sizing: border-box;
      //padding: 0 24px 16px;
      padding: 0 16px;
      box-sizing: border-box;

      width: 226px;
      //width: 242px;
      height: 479px;

      border-radius: 10px;

      margin: 0 8px 8px;

      .price-box {
        font-weight: bold;
        color: #2D2B33;
        text-align: center;
        padding: 12px 0 4px;
        font-size: 0;

        .icon_dollar {
          font-size: 14px;
          line-height: 19px;
        }

        .price {

          font-size: 32px;
          font-weight: bold;
          color: #2D2B33;
          line-height: 40px;
        }

        .time {
          font-size: 16px;
          line-height: 21px;
        }
      }

      .main-box {
        width: 194px;
        height: 51px;
        background: linear-gradient(270deg, rgba(245, 246, 250, 0) 0%, #F5F6FA 47%, rgba(245, 246, 250, 0) 100%);
        border-radius: 1px;
        //margin: 8px 0 7px;
        text-align: center;
        padding-top: 8px;
        box-sizing: border-box;
        margin-bottom: 16px;

        .sub-title {
          letter-spacing: 1px;
          //color: #B17751;
          margin-bottom: 4px;
          font-size: 12px;
          line-height: 16px;

          .text-main {

          }

          .text-account {
            //color: rgba(248, 90, 31, 1);
            //font-weight: bold;
          }


        }

        .down-num {
          font-size: 12px;
          line-height: 16px;
          margin-top: 4px;
        }

      }

      .buy {
        text-align: center;
        font-weight: bold;
        position: relative;
        z-index: 5;
        width: 194px;
        height: 42px;
        line-height: 42px;
        background: #FF5758;
        border-radius: 22px;
        font-size: 14px;
        color: #FFFFFF;

        @include ElementHover('', rgba(255, 104, 105, 1));
      }

      .hr {
        border-bottom: 1px dashed #C5CBE6;
        margin: 31px 0 32px;
      }

      .permission-list {

        &.interests {
          min-height: 64px;
          .permission-item {
            white-space: nowrap;
            &:first-child {
              color: #B57F34;

              @include ElementHover('', '') {
                span {
                  text-decoration: underline;
                }
              }
            }
          }
        }

        .permission-item {
          display: flex;
          //align-items: center;
          margin-bottom: 8px;
          font-size: 12px;
          line-height: 16px;

          .icon-gou2 {
            font-size: 12px;
            color: rgba(0, 170, 116, 1);
            margin-right: 10px;
          }

          .permission-lf {
            color: #424866;
            display: flex;
            //align-items: center;
            justify-content: center;

            i {
              font-size: 18px;
              margin-right: 10px;
            }
          }


        }
      }

      .scene-hr {
        font-size: 14px;
        color: #71758C;
        line-height: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 18px 0 10px;

        .scene-text {
          white-space: nowrap;
        }

        .line {
          display: inline-block;
          width: 110px;
          height: 1px;
          border-bottom: 1px dashed #C5CBE6;
        }
      }
    }

    &:hover {
      &.card-item {
        margin-top: -16px;
      }
    }

  }

  .swiper-slide-custom{
    margin-left: 24px;
    .title{
      color: rgba(52, 57, 129, 1) !important;
    }
  }
  .custom {
    background: linear-gradient(180deg, #FFEEC3 0%, #FFC96C 100%);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 26, 0.1);
    position: relative;

    .icon_custom{
      @include BgImage2(242px, 180px, 'introduce/company/icon_custom.png');
      position: absolute;
      top: 0;
      right: 0;

    }

    .card-content {
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 4px 4px 0px #FEB345;
      backdrop-filter: blur(10px);

      .price-box2 {
        display: flex;
        font-size: 14px !important;
        font-weight: bold;
        color: #B15119 !important;
        line-height: 19px;
        letter-spacing: 1px;
        align-items: center;
        justify-content: center;
        padding: 24px 0 15px !important;


        .icon_company {
          @include BgImage2(16px, 14px, 'introduce/company/icon_company.png');
          margin-right: 6px;
        }
      }

      .main-box {
        background: linear-gradient(270deg, rgba(255, 246, 218, 0) 0%, #FFF6DA 46%, rgba(255, 246, 218, 0) 100%) !important;
        border-radius: 1px;
        color: rgba(65, 71, 155, 1);
      }

      .buy-service {
        display: inline-block;
        background: linear-gradient(227deg, #FF5C4B 0%, #FF007F 100%);
        color: #FFFFFF;
        width: 194px;
        height: 42px;

        &:hover {
          background: linear-gradient(227deg, #FF007F 0%, #FF5C4B 100%);
        }
      }

      .interests {
        .permission-item {
          &:first-child {
            color: rgba(255, 79, 55, 1) !important;
          }
        }
      }
    }


  }
}

.color-blue {
  color: #0C3DD3 !important;
}
</style>
